export default __webpack_public_path__ + "static/media/slider-next.5a3d6aba.svg";